import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DynamicGuardService } from '@workflow/dynamic-guard/dynamic-guard.decorator';
import { UserService } from '../service/user/user.service';
import { StatefulService } from '@app/service/stateful.service';
/**
 * Guard used to restrict user to leave page if PID verification in progress.
 * A confirmation pop-up will be presented to user and response will be passed to guard using observable
 */
@DynamicGuardService('IdentityCheck')
@Injectable({
  providedIn: 'root'
})
export class IdentificationCheckGuard {
  public subscription: Subscription;

  constructor(private readonly userService: UserService, private readonly statefulService: StatefulService) {}

  /**
   * Activating page route by checking isPIDPageVisited
   */
  canActivate(): boolean {
    const IsPrimaryApplicantVisited = this.statefulService.wrap(
      'api:oaoMemberInformation/accountsAndServices/primaryApplicant/pidVerification/isPIDPageVisited'
    ).value;
    if (!this.isMidAppDecisionEnabled() && IsPrimaryApplicantVisited) {
      return false;
    }
    return true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    const isPIDCompletedState = this.statefulService.wrap('api:oaoMemberInformation/isIdentityVerificationCompleted');
    const isPIDAvailable = this.statefulService.wrap('api:oaoMemberInformation/oaoLenderSettings/isPIDQuestionsAvailable').value;
    const isEmptyPID = this.statefulService.wrap('ss:oaoMemberInformation/isEmptyPIDReport').value;
    if (this.isMidAppDecisionEnabled() || isPIDCompletedState.value || !isPIDAvailable || isEmptyPID) return true;
    this.statefulService.wrap('mem:preventPIDVerificationExit').value = true;
    const promise = new Promise<boolean>((resolve) => {
      this.subscription = this.userService.confrimToLeave$.subscribe((leavePage) => {
        this.statefulService.wrap('mem:preventPIDVerificationExit').value = false;
        if (leavePage) {
          isPIDCompletedState.value = true;
        }
        resolve(leavePage);
      });
    }).finally(() => {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    });

    return promise;
  }

  private isMidAppDecisionEnabled(): boolean {
    const bundleValue = this.statefulService.wrap('api:oaoMemberInformation/isMidAppDecisionEnabled').value;
    return typeof bundleValue === 'boolean' ? bundleValue : true;
  }
}
